import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInfoBoxesComponent } from './custom-info-boxes.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {CustomItemInfoBoxModule} from '../custom-item-info-box/custom-item-info-box.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomInfoBoxesComponent],
  exports: [CustomInfoBoxesComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomItemInfoBoxModule,
    ConfigModule.withConfig({
      cmsComponents: {
        InfoBoxesComponent: {
          component: CustomInfoBoxesComponent,
        },
      },
    } as CmsConfig),
    RouterModule,
  ]
})
export class CustomInfoBoxesModule { }
